// The one id the ad platforms match a browser's events on, Meta's external_id: the pixel sends it with every
// event and the server sends the same one, hashed, with its Conversions API copies, so both are known to be
// the same shopper. It is made only once ad tags are allowed, kept in this browser, and never sent anywhere
// else. A browser that will not store it gets a fresh one per page, which matches nothing and harms nothing.

/** Where the id is kept; its own key, apart from the elements' memory, which keeps nothing identifying. */
const KEY = 'xs-ad:visitor';

/** A uuid, the only shape the server takes for it. */
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Reads this browser's ad id, making and keeping one the first time it is asked for.
export function adVisitorId(): string {
  try {
    const kept = window.localStorage.getItem(KEY);
    if (kept && UUID_RE.test(kept)) return kept;
    const made = crypto.randomUUID();
    window.localStorage.setItem(KEY, made);
    return made;
  } catch {
    return crypto.randomUUID();
  }
}
